<template>
	<div class="com-right-content text-white">
		<div >
			<BlockBox title="阵地数量统计" height="306">
				<template #content>
					<div style="padding:0 15px;box-sizing: border-box">
						<div id="chartCddjtj" style="height:225px;"></div>
					</div>
				</template>
			</BlockBox>
		</div>
		<div class="margin-top-15">
			<BlockBox title="活动数量统计" height="306">
				<template #content>
					<div style="padding:0 15px;box-sizing: border-box">
						<div id="chartWzbjtj" style="height:225px;"></div>
					</div>
				</template>
			</BlockBox>
		</div>
		<div class="margin-top-15">
			<BlockBox title="新闻资讯点击统计" height="306">
				<template #content>
					<div style="padding:0 15px;box-sizing: border-box">
						<div class="wzdjItem base-font-12" v-for="(obj,index) in item.list" :key="index" >
							<el-row v-if="index<7">
								<el-col :span="2"><div class="leftNum text-center" :class="index==0?'one':index==1?'two':''">0{{index+1}}</div></el-col>
								  <el-col :span="17">
									  <div class="ellipsis">{{obj.title}}</div>
									</el-col>
							  <el-col :span="5"><div class="text-right">{{obj.readNum}}</div></el-col>
							</el-row>
						</div>
					</div>
				</template>
			</BlockBox>
		</div>
		
	</div>
</template>

<script>
	import echartMixins from "@/utils/resizeMixins";
	import BlockBox from '@/views/components/blockBox'
  import {rightData} from "@/api/api";
	export default {
		name: "cityGreenLand",
		components: {BlockBox},
		mixins: [echartMixins],
		data() {
			return {
        item:{},
				nhLable: ['访问人数', '成交次数'],
				nhLableCurrent:0,
				colors: ['#f0792a', '#4b3eeb', '#247bf1', "#67e591", '#05d3f8', '#c0f02a', ],
				wzdjPm:[
					{id:1,title:"文章名称文章名称文章名称文章名称文章名称",djl:13234},
					{id:1,title:"文章名称文章名称文章名称文章名称文章名称",djl:13234},
					{id:1,title:"文章名称文章名称文章名称文章名称文章名称",djl:13234},
					{id:1,title:"文章名称文章名称文章名称文章名称文章名称",djl:13234},
					{id:1,title:"文章名称文章名称文章名称文章名称文章名称",djl:13234},
					{id:1,title:"文章名称文章名称文章名称文章名称文章名称",djl:13234},
					{id:1,title:"文章名称文章名称文章名称文章名称文章名称",djl:13234},

				]
				// mrhnDay: ['12/05', '12/06', '12/07', '12/08', '12/09'],
			}
		},
		mounted() {
			this.changeData()
		},
		methods: {
      changeData(){
        let _self=this
        rightData().then(res => {
          _self.item=res.data;
          _self.$nextTick(function() {
            _self.drawCddjtj();
            _self.drawWzbjtj()
          });
        });
      },
			drawWzbjtj() {
				this.chart = this.$echarts.init(document.getElementById("chartWzbjtj"));
        let dateList=[];
        let dateValue=[];
        this.item.activityList.forEach(obj=>{
          dateList.push(obj.name);
          dateValue.push(obj.value);
        })
				let option = {
					grid: {
						left: '3%',
						right: '3.5%',
						bottom: '3%',
						top:20,
						containLabel: true
					},
					tooltip: {
						trigger: 'axis'
					},
					xAxis: {
						type: 'category',
						
						axisTick: {
							show: false,
						},
						data:dateList,
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.1)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#2da3ff'
							}
						}
					},
					yAxis: {
						type: 'value',
						axisTick: {
							show: false,
						},
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.1)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#ffffff',
								fontSize: 10
							}
						}
					},
					series: [
						{
						name: '数量',
						type: 'bar',
						barWidth:9,
						data: dateValue,
						itemStyle: {
								normal: {
									label: {
										show: true, //开启显示
										position: 'top', //在上方显示
										textStyle: {
											//数值样式
											color: 'white',
											fontSize: 12,
										},
									},
								color: { // 填充的颜色 // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
											offset: 0,
											color: 'rgba(71, 71, 255, 1)', // 0% 处的颜色
										},
										{
											offset: 1,
											color: 'rgba(51, 30, 255, 1)' // 100% 处的颜色
										}
									],
									global: false, // 缺省为 false
								}
						      }
							  },
			
				
						}
					]
				};
				// echart图表自适应
				this.chart.setOption(option)
				window.addEventListener("resize", () => {
					this.chart.resize();
				});
			},
					
			drawCddjtj() {
				this.chart = this.$echarts.init(document.getElementById("chartCddjtj"));
        let dateList=[];
        let dateValue=[];
        this.item.positionList.forEach(obj=>{
          dateList.push(obj.name);
          dateValue.push(obj.value);
        })
				let option = {
					grid: {
						left: '3%',
						right: '3.5%',
						bottom: '3%',
						top:20,
						containLabel: true
					},
					tooltip: {
						trigger: 'axis'
					},
					xAxis: {
						type: 'category',
						
						axisTick: {
							show: false,
						},
						data:dateList,
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.1)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#2da3ff'
							}
						}
					},
					yAxis: {
						type: 'value',
						axisTick: {
							show: false,
						},
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.1)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#ffffff',
								fontSize: 10
							}
						}
					},
					series: [
						{
						name: '数量',
						type: 'bar',
						barWidth:9,
						data: dateValue,
						itemStyle: {
								normal: {
									label: {
										show: true, //开启显示
										position: 'top', //在上方显示
										textStyle: {
											//数值样式
											color: 'white',
											fontSize: 12,
										},
									},
								color: { // 填充的颜色 // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
											offset: 0,
											color: 'rgba(1, 108, 190, 1)', // 0% 处的颜色
										},
										{
											offset: 1,
											color: 'rgba(1, 38, 77, 1)' // 100% 处的颜色
										}
									],
									global: false, // 缺省为 false
								}
						      }
						},
	
					}, 
					]
				};
				// echart图表自适应
				this.chart.setOption(option)
				window.addEventListener("resize", () => {
					this.chart.resize();
				});
			},
		
			
		}
	}
</script>

<style lang="scss">
	.com-right-content {
		min-height: 500px;
		padding: 14px 15px 15px 15px;
		box-sizing: border-box;
		.wzdjItem{width:100%;height:35px;line-height:21px;padding:11px 0;cursor: pointer;}
		.wzdjItem:hover{color:#006AF6;}
		.wzdjItem .leftNum{width:21px;height:21px;border-radius:2px;background:#006AF6;line-height:21px;text-align: center;}
		.wzdjItem .leftNum.one{
			background: -webkit-linear-gradient(top, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
			/* Safari 5.1 - 6.0 */
			background: -o-linear-gradient(bottom, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
			/* Opera 11.1 - 12.0 */
			background: -moz-linear-gradient(bottom,rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
			/* Firefox 3.6 - 15 */
			background: linear-gradient(to bottom,rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
		}
		.wzdjItem .leftNum.two{
			background: -webkit-linear-gradient(top, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
			/* Safari 5.1 - 6.0 */
			background: -o-linear-gradient(bottom,  rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
			/* Opera 11.1 - 12.0 */
			background: -moz-linear-gradient(bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
			/* Firefox 3.6 - 15 */
			background: linear-gradient(to bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
		}
		.shtjBox{
			height:250px;
			 & .swiper{height:250px;}
		}
	}
	

	.hnzbLable {
		margin-top: 10px;
	}

	.hnzbLable .itemLable {
		line-height: 1;
		border: 1px solid;
		color: #2196f3;
		font-size: 12px;
		padding: 5px 7px;
		border-radius:1px;
	}

	.hnzbLable .itemLable+.itemLable {
		margin-left: 7px;
	}

	.hnzbLable .itemLable.checked {
		background: #006AF6;
		color: #FFFFFF;
		border-color: #006AF6;
	}

</style>
